export const newSearch = async (searchParams) => {
    const fetchProps = {
        method: "POST",
        headers: {
            Accept: "application/json",
            "Content-Type": "application/json;charset=UTF-8"
        },
        body: JSON.stringify(searchParams)
    };

    const resp = await fetch(`/search/`, fetchProps);
    return resp.json();
};
